<template>
  <Transition appear name="region-selector_animate">
    <div class="region-selector">
      <button class="region-selector_close" @click="close" />
      <Transition appear name="region-selector_content-animate">
        <div class="region-selector_holder">
          <p class="region-selector_title">{{ $t('Выбор страны выпуска и получения карты') }}</p>
          <p class="region-selector_description">{{ $t('Содержание и условия программы зависят от выбранной страны.') }}</p>
          <RegionSelector @selected="close" />
        </div>
      </Transition>
    </div>
  </Transition>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import RegionSelector from './RegionSelector.vue'

@Component({
  components: { RegionSelector }
})
class RegionSelectOverlay extends Vue {
  close () {
    this.$emit('close')
  }
}

export default RegionSelectOverlay
</script>

<style lang="scss">
$content_width: 100%;

.region-selector {
  background: #141414;
  padding: 46px 0 43px;
  bottom: 0;
  left: 0;
  line-height: 1.7;
  margin-bottom: 0;
  position: fixed;
  right: 0;
  top: 0;
  opacity: 1;
  text-align: center;
  visibility: visible;
  width: 100%;
  z-index: 10001;
  @include media_tablet {
    background: #0a0a0b;
    position: absolute;
    left: 0;
    top: auto;
    bottom: calc(100% + 1px);//1px - footer border width

    &:after {
      content: "";
      background: rgba(0, 0, 0, .8);
      position: absolute;
      left: 0;
      bottom: 100%;
      width: 100%;
      height: 100vh;
    }
  }
  &_holder {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    max-width: $content_width;
    margin: 0 auto;
    padding: 0 20px;
    transform: scale(1);
  }
  &_title {
    color: #fff;
    font-size: 18px;
    font-weight: 400;
    margin-bottom: 6px;
  }
  &_description {
    font-size: 14px;
  }
  &_close {
    @include invisible-text;
    @include button-normalize;
    padding: 10px;
    position: absolute;
    right: 20px;
    top: 20px;

    &:after {
      @include invisible-text;
      background: {
        image: url("#{$common-images}/svg/cross.svg");
        size: contain;
      }
      content: "";
      display: block;
      height: 14px;
      width: 14px;
      transition: opacity $duration;
      @include media_tablet {
        opacity: .5;
      }
    }
    &:hover:after {
      @include media_tablet {
        opacity: 1;
      }
    }
  }
  &_animate {
    &-enter {
      opacity: 0;
      visibility: hidden;
      @include media_tablet {
        transform: translateY(35px);
      }
    }
    &-enter-active {
      transition: opacity .3s ease,
                  transform .3s ease,
                  visibility 0s ease 0s;
    }
    &-leave-to {
      opacity: 0;
      @include media_tablet {
        transform: translateY(35px);
      }
    }
    &-leave-active {
      transition: opacity $duration*2 ease-in-out $duration*2,
                  transform $duration*2 ease-in-out $duration*2,
                  visibility $duration*2 linear $duration*2;
      @include media_tablet {
        transition: opacity $duration ease-in-out $duration,
                    transform $duration ease-in-out $duration,
                    visibility $duration linear $duration;
      }
    }
  }
  &_content-animate {
    &-enter,
    &-leave-to {
      opacity: 0;
      transform: scale(.95);
    }
    &-enter-active {
      transition: $duration opacity $duration,
                  $duration transform $duration;
    }
    &-leave-active {
      transition: opacity $duration,
                  transform $duration;
    }
  }
}
</style>
